<div class="white-wrap-admin" *ngIf="showView">
  <div class="">
    <div class="back-link-outer mb-3 d-flex">
      <a class="back-link" [routerLink]="['/admin/dashboard/news/']">
        <img alt="back" src="../assets/images/back.svg" /> back
      </a>
    </div>

    <div class="row">
      <div class="col-12 mb-3 mb-md-4">
        <h1 class="heading-24 m-0">
          {{ actionText }}
        </h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <form [formGroup]="blogForm">
          <div class="form-group">
            <div class="mat-field-width">
              <mat-form-field appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput type="text" id="title" formControlName="title" placeholder="Title" required />
              </mat-form-field>
            </div>
            <control-messages [control]="blogForm.controls.title"></control-messages>
          </div>

          <div class="form-group">
            <div class="mat-field-width">
              <mat-form-field appearance="outline">
                <mat-label>Author *</mat-label>
                <input matInput type="text" id="author" formControlName="author" placeholder="author" />
              </mat-form-field>
            </div>
            <control-messages [control]="blogForm.controls.author"></control-messages>
          </div>

          <div class="form-group pb-0 pb-md-3">
            <div class="mat-field-width">
              <p class="small-label mb-3">Display Picture *</p>
              <div class="custom-file-upload mb-2">
                <span class="upload-inner mb-4">
                  <div *ngIf="imagePreviewUrl != null; else showPlaceholder">
                    <img class="thumb-image" width="150" [src]="imagePreviewUrl" />
                  </div>
                  <ng-template #showPlaceholder>
                    <img class="thumb-image" src="../assets/images/thumbnail-square.jpg" />
                  </ng-template>

                  <img class="upload-btn" src="../assets/images/ic-upload-photo.svg" role="button"
                    (click)="fileInput.click()" />
                </span>
              </div>

              <p class="upload-note m-0">
                Recommended Size : 1024 * 720 px
                <br />
                File size should not exceed {{ +blogSize | fileSize }}
              </p>

              <input style="display: none" type="file" [accept]="blogFormat"
                (change)="onFileChanged($event.target.files)" #fileInput />
              <control-messages [control]="blogForm.controls.coverImage">
              </control-messages>
            </div>
          </div>

          <div class="form-group">
            <div class="mat-field-width2">
              <p class="small-label mb-3">Content *</p>
              <editor [imageUploadUrl]="'api/news/uploadFiles'" [initialValue]="blogContent"
                (editorData)="editorContent($event, blogForm.controls.content)"></editor>
              <control-messages [control]="blogForm.controls.content">
              </control-messages>
            </div>
          </div>
        </form>

        <div class="mt-4 pt-0 pt-md-2">
          <button role="button" (click)="onCancel()" class="btn btn-white-border mr-2">
            Cancel
          </button>

          <button [disabled]="blogForm.invalid || submitted" class="btn btn-white-border btn-white-border2 mr-2"
            role="button" (click)="onSubmit(false)">
            <span *ngIf="submitted && !isPublishLoader" class="spinner-border spinner-border-sm ml-2"></span>
            Save As Draft
          </button>

          <button [disabled]="blogForm.invalid || submitted" class="btn btn-colored" role="button" (click)="onSubmit()">
            <span *ngIf="submitted && isPublishLoader" class="spinner-border spinner-border-sm ml-2"></span>
            Publish News
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
